import React, { useState } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import questions from "./data.js";

const Question = ({ title, info }) => {
  const [collapse, setColapse] = useState(false);

  function showInfo() {
    if (!collapse) setColapse(true);
    else setColapse(false);
  }

  return (
    <article className="question">
      <header>
        <h4>{title}</h4>
        <button className="btn" onClick={showInfo}>
          {!collapse ? <AiOutlinePlus /> : <AiOutlineMinus />}
        </button>
      </header>
      <p>{collapse && info}</p>
    </article>
  );
};

export default Question;
